"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _DefaultButton = _interopRequireDefault(require("./DefaultButton"));

var _typography = require("../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecondaryButton = (0, _styledComponents.default)(_DefaultButton.default).withConfig({
  displayName: "SecondaryButton",
  componentId: "q22o88-0"
})(["font:inherit;fill:", ";color:", ";background:", ";border-radius:4px;border-color:", ";padding:8px;", " &:hover,&:focus{color:", ";background:", ";", ",svg{color:", ";}}&:active{background-size:100%;transition:background 0s;}"], (0, _helpers.color)('primary'), (0, _helpers.color)('primary'), (0, _helpers.color)('white'), (0, _helpers.color)('primary'), function (p) {
  return p.hasText && "padding: 8px 20px;";
}, (0, _helpers.colorToAlpha)('primary', 0.4), (0, _helpers.color)('white'), _typography.Body, (0, _helpers.color)('primary'));
var _default = SecondaryButton;
exports.default = _default;